interface GTMPayload {
  [key: string]: any;
}

export const pushToDataLayer = (
  event: string,
  payload: GTMPayload = {}
): void => {
  if (typeof window !== "undefined") {
    const w = window as unknown as { dataLayer?: any[] };

    if (!w.dataLayer) {
      console.warn("GTM dataLayer is not initialized");
      return;
    }

    w.dataLayer.push({
      event,
      ...payload,
    });
  }
};